 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BannerDataState } from '../../actions/types/schedule-maintenance/GetBannerDataTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: BannerDataState = {
  isLoading: true,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  BannerDataDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const getBannerDataSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getBannerDataStarted: (state) => {
      state.isLoading = true;
    },

    getBannerDataSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.BannerDataDetails = action.payload;
    },

    getBannerDataFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.BannerDataDetails = initialState.BannerDataDetails;
    },

    clearBannerData: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.BannerDataDetails = initialState.BannerDataDetails;
    }
  }
});

export const {
  getBannerDataStarted,
  getBannerDataSuccess,
  getBannerDataFail,
  clearBannerData
} = getBannerDataSlice.actions;
export default getBannerDataSlice.reducer;
